import { createFileRoute } from '@tanstack/react-router';
import CreateCollateralClause from '../../../features/baseData/collateralClauses/collateralClause/create';
import {
  COLLATERAL_CLAUSES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/nebenbestimmungen/neu')({
  component: CreateCollateralClause,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COLLATERAL_CLAUSES_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateCollateralClauseRoute = Route;
